<mh-change-image [textButton]="'attached'" (attachment)="setAttachment($event)"></mh-change-image>